module.exports = __webpack_public_path__ + "static/media/earthDefence.eeb804e0.png";